export const STEP = {
  RESUME: 'resume',
  USER_INFORMATION: 'user',
  COMPANY_INFORMATION: 'company',
  CRM_TASK: 'crmTask',
  STORE_COMPARE: 'storeCompare',
  CRM_TASK_COMMENT_ENTITY: 'crmTaskCommentEntity',
  PASSWORD: 'password',
  SECURITY: 'security',
  NEWSLETTER: 'newsletter',
  MY_AVATAR: 'my_avatar',
  ROLES: 'roles',
  SFTP: 'sftp',
  CREDIT_HISTORIES: 'creditHistories',
  MY_TEAM: 'myTeam',
  SCHOOL_MANAGEMENT: 'schoolManagement',
  CONTRACT_SCHOOL: 'contractSchool',
  STORE_MANAGEMENT: 'storeManagement',
  SOUND_INDUSTRY_MANAGEMENT: 'soundIndustryManagement',
  LGO_MANAGEMENT: 'lgoManagement',
  /** Segmentation partenaire d'un laboratoire (sous-groupes), onglet admin. */
  SUBGROUPS: 'subgroups',
  /** Produits PLV du laboratoire (tableaux + ordre d'affichage), onglet gestion. */
  PARTNER_PRODUCTS: 'partnerProducts',
  /** Campagnes partenaires du laboratoire (liste + création), onglet gestion. */
  PARTNER_CAMPAIGNS: 'partnerCampaigns',
  /** Laboratoires partenaires d'une pharmacie, onglet admin. */
  PARTNERS: 'partners',
  SOUND_MANAGEMENT: 'soundManagement',
  INVOICE_SOUND: 'invoiceSound',
  PROGRAM_SOUND: 'programSound',
  REPORTING_SOUND: 'reportingSound',
  CONTRACT_SOUND: 'contractSound',
  BANK: 'bank',
  SEGMENTATION: 'segmentation',
  GESTION_INSIGHT: 'insight',
  INVOICE_INSIGHT: 'invoiceInsight',
  SURVEY: 'survey',
  CONTRACT_INSIGHT: 'contractInsight',
  STORE_BAG_MANAGEMENT: 'storeBagManagement',
  STORE_BAG_PROGRAM: 'storeBagProgram',
  CONTRACT_STORE_BAG: 'storeBagContract',
  INVOICE_STORE_BAG: 'invoiceStoreBag',
  CARE_MANAGEMENT: 'careManagement',
  MAIL_USER: 'mail',
  SCHOOL: 'school',
  POINTS_SHOP_HISTORY: 'pointsShopHistory',
  OLD_USER: 'oldUser',
  AI_CREDITS: 'aiCredits',
  PREFERENCES: 'preferences',
  INVOICES: 'invoices',
  CONTRACTS: 'contracts',
  PROGRAMS: 'programs',
  /** Commandes de la centrale d'achat (CS-Cart) et export de leurs factures. */
  STORE_ORDERS: 'storeOrders',
  ADMIN: 'admin',
  /** Parametrage entreprise (fiches labo/groupement). */
  COMPANY_SETTINGS: 'companySettings',
  /** Laboratoires d'un groupement / d'une chaine : partenaires mis en avant et factures visibles. */
  GROUPEMENT_LABORATORIES: 'groupementLaboratories',
  /** Pharmacies rattachees a un URPS par leur code postal. */
  URPS_PHARMACIES: 'urpsPharmacies',
  /** Journal d'audit de la fiche (Gedmo Loggable) : qui a modifie quoi et quand. */
  HISTORY: 'history',
} as const
